import { EventListener } from '../model'

class Strategy {
  eventListener?: EventListener

  update() {
    if (this.eventListener) {
      this.eventListener()
    }
  }

  onUpdate(eventListener: EventListener) {
    this.eventListener = eventListener
  }
}

export default Strategy
